import * as React from 'react';

import {
    TenantLoginText,
} from '../../Store/Tenant';

import { PortalTextLogin } from '../../Models/Api/strongbox.financialportal';
import LoginButton from './LoginButton';

import { UIRedirectInfo } from '../../Store/UIState';

const teamDelimiter = '<team>'

export function GenerateCommonLoginContent(
    welcomeText: TenantLoginText[],
    loginThisPortalName: string,
    showLoginButton: boolean,
    placeButtonAfterLine: number,
    separatorAfterWelcome: boolean,
    portalLoginText?: PortalTextLogin,
    redirect?: UIRedirectInfo,
    portalLanguage?: string,
): { content: React.ReactElement; rowClassName?: string}[] {
    const result: { content: React.ReactElement; rowClassName?: string}[] = [];

    welcomeText.forEach((pg, pgIndex) => {
        const textContent = pg.content;
        const stringComponents = textContent.split(teamDelimiter);
        let pgStyle: React.CSSProperties = {};

        if (!!pg.bold) {
            pgStyle['fontWeight'] = 'bold';
        }
        if (!!pg.fontSize) {
            pgStyle['fontSize'] = `${pg.fontSize}px`;
        }
        if (!!pg.bottomMargin) {
            pgStyle['marginBottom'] = `${pg.bottomMargin}px`;
        }
        // Guaranteed to have at least one element in stringComponents
        const pgElement = (
            <p
                className={'login-text'}
                style={pgStyle}
                key={`tenant-welcome-paragraph-${pgIndex}`}
            >
                {stringComponents[0]}
                {stringComponents.map((component, index) => {
                    if (index === 0) {
                        return (<React.Fragment key={`tenant-welcome-paragraph-${pgIndex}-${index}`}></React.Fragment>);
                    } else {
                        return (
                            <React.Fragment key={`tenant-welcome-paragraph-${pgIndex}-${index}`}><b>{` ${loginThisPortalName}`}</b>{` ${component}`}</React.Fragment>
                        );
                    }
                })}
            </p>
        )

        result.push({content: pgElement});

        if (showLoginButton && (!!portalLoginText) && ((pgIndex + 1) === placeButtonAfterLine)) {
            result.push({ content: (
                            <LoginButton
                                redirectInfo={redirect}
                                autoNavToLogin={false}
                                buttonText={portalLoginText?.loginButton}
                                portalLanguage={portalLanguage}
                            />
                            ),
                            rowClassName: 'absolute-row' });
        }
    });

    if (separatorAfterWelcome) {
        result.push({
            content: (<div className={'separator-line'} />),
        })
    }

    return result;
}